/** Rubrikstil för tabellhuvuden – delas av revisionens tabeller. */
export const rubrikSx = {
  fontSize: 11,
  letterSpacing: 0.5,
  textTransform: 'uppercase',
  color: 'text.secondary',
  verticalAlign: 'bottom',
} as const;
